// File: frontend/src/pages/KnowledgeGraph/components/HeroHeader.tsx
import React from 'react';
import { Box, Typography, Chip, Stack, Link, styled, alpha } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { Link as RouterLink } from 'react-router-dom';
import { cyber } from '../../../theme';

const HeroSection = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${cyber.bgPaper} 0%, #3a2d6e 55%, ${cyber.primary} 130%)`,
  border: `1px solid ${alpha(cyber.primary, 0.35)}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    right: '-10%',
    width: '300px',
    height: '300px',
    background: alpha(cyber.primaryLight, 0.25),
    borderRadius: '50%',
    filter: 'blur(80px)',
  },
}));

const HeroHeader: React.FC = () => {
  return (
    <HeroSection>
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
          <HubIcon sx={{ fontSize: 36 }} />
          <Typography variant="h4" component="h1" fontWeight="bold">
            STIX Constellation
          </Typography>
          <Chip label="Beta" color="warning" size="small" />
        </Stack>
        <Typography variant="h6" sx={{ opacity: 0.95, mb: 1.5 }}>
          Explore cross-report threat intelligence relationships
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
          <Link
            component={RouterLink}
            to="/knowledge-graph/about"
            sx={{ color: alpha('#fff', 0.85), fontSize: '0.85rem', '&:hover': { color: cyber.accent.cyan } }}
          >
            What is STIX Constellation?
          </Link>
          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            This feature is in active development.{' '}
            <Link
              component={RouterLink}
              to="/feedback"
              sx={{ color: alpha('#fff', 0.85), '&:hover': { color: cyber.accent.cyan } }}
            >
              Your feedback helps us improve it.
            </Link>
          </Typography>
        </Stack>
      </Box>
    </HeroSection>
  );
};

export default HeroHeader;
